module.exports = __webpack_public_path__ + "img/avatar3.ec3c8f9c.png";